var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
import { Navigate, useParams } from 'react-router-dom';
import { useAuthProvider } from '#context';
export const UserMemberOfPartnerOrganizationRouteGuard = ({ children, }) => {
    _react_refresh_temp_2();
    const { contextOrgId = '' } = useParams();
    const { currentUser } = useAuthProvider();
    if (currentUser?.partnerOrganizations?.some((organization) => {
        return organization.id === contextOrgId;
    })) {
        return children;
    }
    return _jsx(Navigate, { to: "/workspaces" });
};
_react_refresh_temp_1 = UserMemberOfPartnerOrganizationRouteGuard;
$RefreshReg$(_react_refresh_temp_1, "UserMemberOfPartnerOrganizationRouteGuard");
_react_refresh_temp_2(UserMemberOfPartnerOrganizationRouteGuard, "PvFmYVM5LvhfgTYTvco3hCkOQOU=", false, () => [useParams, useAuthProvider]);
